// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2kOkA","paramInput":"JobSimulator_paramInput__1ai55","input":"JobSimulator_input__1JYfO"};